
(function(template){
  define('vue!app/views/vue/components/packageDivComponent/packageScheduleComponent/packageInfo',[
    "Vue",
    "helpers",
    "vuex",

  ], function (
    Vue,
    helpers,
    vuex
  ) {
    return {
      template: template,
      name: "",
      props: ['dataInPackageInfoBox','scheduling_package'],
      data: function () {
        return {}
      },
      computed: _.extend(
        vuex.mapState(['desktopMode']), {

            packageInfoShow:function(){
                return !this.desktopMode && this.dataInPackageInfoBox.length && this.scheduling_package
            }
        }),
      components: {},
      methods: {},
    }
  })
})('<div class="package-info" v-if="packageInfoShow"> <div class="service-time-picker-div"> <h1> <span>{{localStrings.stepper.body.schedule.packageInfoMobile.label }}</span> </h1> <div class="package-info-box-booking-outer-div"> <div class="package-info-box-booking" v-for="(item,key) in dataInPackageInfoBox" :key="key"> <p class="package-info-box-name">{{item.name}}</p> <p class="package-info-box-time"> <label>{{localStrings.stepper.body.schedule.packageInfoMobile.timeLabel }}: </label> <span>{{item.startTime}}</span> </p> </div> </div> </div> </div>');
